/**
 * A progress meter fills from empty to its share the first time it comes on screen. The pending state
 * holds the fill hidden until it plays (modules/motion/once.js); the fill grows with `scale`, so a script
 * that later changes its width still transitions on its own property.
 */
import {EASING_CURVES} from '../modules/motion/easing.js';
import {playOnce} from '../modules/motion/once.js';

const SELECTOR = Object.freeze({
    root: '.js-progressMeter',
    fill: '[role="progressbar"]',
});

/** Milliseconds. */
const FILL_DURATION = 900;

/**
 * @param {HTMLElement} root
 */
export function initializeProgressMeter(root) {
    playOnce(root, (run) => {
        const fill = root.querySelector(SELECTOR.fill);
        if (!(fill instanceof HTMLElement)) {
            throw new Error('progressMeter: a meter needs its fill.');
        }
        run.add(fill.animate([{scale: '0 1'}, {scale: '1 1'}], {duration: FILL_DURATION, easing: EASING_CURVES['ease-out-quint'], fill: 'backwards'}));
    });
}

/**
 * Initialize every meter that is not initialized yet. Safe to call after content swaps.
 */
export function initializeProgressMeters() {
    for (const root of document.querySelectorAll(SELECTOR.root)) {
        if (root instanceof HTMLElement) {
            initializeProgressMeter(root);
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProgressMeters);
} else {
    initializeProgressMeters();
}
document.addEventListener('htmx:load', initializeProgressMeters);
